<template>
  <div class="ConfInter">
    <div class="titlePage">Casos Ibero</div>
    <va-notification color="danger" v-if="refNoData" class="refNoData">El servicio que ejecuta el llamado no se encuentra activo.</va-notification>
    <div class="listData">
      <DataList
        :InfoView="this.DLDataList"
        :HeadTable="this.HDDataList"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataListCase.vue'

export default {
  name: 'ConfInter',
  data () {
    return {
      HDDataList: [
        {
          name: 'CaseId',
          title: 'Caso',
          width: '10%',
        },
        {
          name: 'CaseDetail',
          title: 'Detalle',
          width: '40%',
        },
        {
          name: '__slot:dateCretedIni',
          title: 'Fecha Inicio',
          dataClass: 'text-left',
          width: '20%',
        },
        {
          name: '__slot:dateCretedFin',
          title: 'Fecha Fin',
          dataClass: 'text-left',
          width: '20%',
        },
        {
          name: 'CaseTypeName',
          title: 'Tipo de caso',
          width: '20%',
        },
        {
          name: '__slot:status',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLDataList: [],
      refNoData: false,
      caseModel: [],
      formUpdate: [],
      renderComponent1: false,
      renderComponent2: false,
    }
  },
  components: {
    DataList,
  },
  methods: {
    loadListCases () {
      let loader = this.$loading.show()
      var casesData = IberoHelpers.getCasesData(this.$store)
      casesData.then(Response => {
        if (Response.data) {
          this.DLDataList = Response.data.Cases
          IberoHelpers.forceRerender1(this)
        } else {
          this.refNoData = true
        }
        loader.hide()
      })
    },
  },
  created: function () {
    this.loadListCases()
  },
}
</script>